//
import Model from '@/models/Model'

/**
 * 
 */
export default class ASuggestBarAuthCode extends Model {

    /**
     * @description
     */
    resource () {
        return 'suggest_bar_auth_code'
    }
}